export enum FieldTypes {
  text = 'text',
  phone = 'phone',
  code = 'code',
  radio = 'radio',
  select = 'select',
}
